import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "form", "button" ]
  connect() {
    this.buttonTarget.click()
  }
}
